import { Dialog, DialogContent, DialogTitle } from '../ui/dialog';
import ProfileTabAccountInfoCodes from '../ProfileTabAccountInfoCodes';
import { useState } from 'react';
import { Button } from '../ui/button';
import { XIcon } from 'lucide-react';

export default function PromoCodeSelectionDialog({
  open,
  onOpenChange,
  onCodeClick,
  closeDialog,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  closeDialog: () => void;
  onCodeClick?: (code: string) => void;
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogTitle className="hidden" />
      <DialogContent
        className="sm:max-w-[800px]"
        onInteractOutside={closeDialog}
        aria-describedby=""
      >
        <Button variant="ghost" className="absolute top-5 right-2" onClick={closeDialog}>
          <XIcon className="size-4" />
        </Button>
        <ProfileTabAccountInfoCodes onCodeClick={onCodeClick} />
      </DialogContent>
    </Dialog>
  );
}
